<template>
  <div>
    <a class="btn-blue" href="#" @click="showing = true"><span>+ Add Note</span></a>
    <card-modal :showing="showing" class="px-4 py-2" @close="showing = false">
      <h2 class="font-bold text-3xl">Add Notes</h2>
      <span class="text-gray-400">Max 200 characters</span>
      <form class="mt-6" @submit.prevent="store">
        <textarea-input v-model="form.description" rows="4" :error="form.errors.description" class="w-full" />
        <div class="flex items-center justify-end mt-6">
          <a class="border text-blue-800 border-blue-800 px-4 py-2 mr-4 cursor-pointer hover:text-white hover:bg-blue-600" @click.stop="showing = false">Cancel</a>
          <loading-button :loading="form.processing" class="btn-blue px-4 py-2" type="submit">Save Note</loading-button>
        </div>
      </form>
    </card-modal>
  </div>
</template>

<script>
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import CardModal from '@/Shared/CardModal'

export default {
  components: {
    LoadingButton,
    TextareaInput,
    CardModal,
  },
  remember: 'form',
  props:{
    project: {
      type: Object,
      default: () => {},
    },
    run: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showing: false,
      form: this.$inertia.form({
        description : null,
      }),
    }
  },
  methods: {
    store() {
      let route = `/notes/${this.project.id}`
      if (this.run) {
        route+= `/${this.run.id}`
      }

      this.form.post(route, {
        onSuccess: () => {
          this.form.reset()
          this.showing = false
        },
      })
    },
  },
}
</script>
